import I18n from 'i18n-js';
import React from 'react';
import errorImageSrc from '../../../images/top-level/500.svg';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import * as Sentry from '@sentry/browser';

interface Props {
  hide?: boolean;
}

const SENTRY_SEARCH = 'https://sentry.io/organizations/reverb-llc/issues/?query=';

export default function ErrorDisplay(props: Props) {
  const currentUser = useUser();
  if (props.hide) {
    return null;
  }

  const eventId = Sentry.lastEventId() || currentUser.requestId;
  const sentryLink = `${SENTRY_SEARCH}${eventId}`;

  return (
    <div className="error scaling-mtb-5 align-center">
      <img src={errorImageSrc} alt={I18n.t('discovery.errorAltText')} />
      <div className="mb-1">
        <h3 className="heading-3 scaling-mb-half">
          {I18n.t('discovery.errorDisplay.message')}
        </h3>
        <h3 className="heading-3">
          {I18n.t('discovery.errorDisplay.looking')}
        </h3>
      </div>
      <a href="/" className="button button--primary mr-half mobile-mb-half">
        {I18n.t('discovery.errorDisplay.homepage')}
      </a>
      <a href="/page/contact" className="button">
        {I18n.t('discovery.errorDisplay.contact')}
      </a>
      {currentUser.isAdmin && <div className="mt-2">
        <a href={sentryLink} className="button-as-link color-red icon-l-search">
          Sentry Error Search
        </a>
      </div>}
      <div className="mt-3 d-flex fx-justify-center">
        <pre>
          <code className="code-snippet">
            {eventId}
          </code>
        </pre>
      </div>
    </div>
  );
}
